/* eslint-disable class-methods-use-this */
import axios from 'axios'

class AuthService {
    constructor() {
        this.accessToken = localStorage.getItem('accessToken');
        this.refreshToken = localStorage.getItem('refreshToken');
    }

    getCode = async (email) =>  {
      console.log(email);
        return axios.post("/api/auth/email/start", {
            email
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(result => result).catch(error => {
            if ('response' in error && error.response !== undefined) {
                throw error.response.data;
            }
            else {
                throw error;
            }
        });
    }

    checkAutorization = () => {
        return axios.post("/api/auth/check", {}, {
            headers: {
                Authorization: `Bearer ${this.accessToken}`
            }
        }).then(result => result).catch(error => {
            if ('response' in error && error.respone !== undefined) {
                throw error.response.data;
            }
            else {
                throw error;
            }
        })
    }


    getNewTokens = (email, code) => {
        return axios.post("/api/auth/email/commit", {
            email,
            code
        }, {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(result => {
            const {accessToken, refreshToken} = result.data.tokenPair;
            this.saveToken(accessToken, refreshToken);
            this.accessToken = accessToken;
            this.refreshToken = refreshToken;
            return result
        }).catch(error => {
            if ('response' in error && error.respone !== undefined) {
                throw error.response.data;
            }
            else {
                throw error;
            }
        });
    }

    refreshAccessToken = () => {

        return axios.post("/api/auth/access-token/refresh", {
            token: this.refreshToken
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(result => {
            const {accessToken, refreshToken} = result.data;
            this.saveToken(accessToken, refreshToken);
            this.accessToken = accessToken;
            this.refreshToken = refreshToken;
            return result;
        }).catch(error => {
            if ('response' in error && error.response !== undefined) {
                throw error.response.data;
            }
            else {
                throw error;
            }
        });

    }

    logOut = () => {
        return axios.post("/api/auth/logout", {}, {
            headers: {
                Authorization: `Bearer ${this.accessToken}`
            }
        }).then(result => {
            this.removeTokens();
            return result;
        }).catch(error => {
            if ('response' in error && error.respone !== undefined) {
                throw error.response.data;
            }
            else {
                throw error;
            }
        });


    }

    saveToken(accessToken, refreshToken) {
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('refreshToken', refreshToken);
    }

    getAccessToken() {
        return this.accessToken
    }

    getRefreshToken() {
        return this.refreshToken

    }

    removeTokens() {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
    }
}

export default AuthService;
